export enum FireWeatherEvent {
  RedFlagWarning = 'Red Flag Warning',
  FireWeatherWatch = 'Fire Weather Watch',
}

export enum FloodWarningEvent {
  ArealFloodWarning = 'Areal Flood Warning',
  CoastalFloodWarning = 'Coastal Flood Warning',
  FlashFloodStatement = 'Flash Flood Statement',
  FlashFloodWarning = 'Flash Flood Warning',
  FloodStatement = 'Flood Statement',
  FlashFloodEmergency = 'Flash Flood Emergency',
  FloodWarning = 'Flood Warning',
  HazardousWeatherOutlook = 'Hazardous Weather Outlook',
  HurricaneWarning = 'Hurricane Warning',
  LakeshoreFloodWarning = 'Lakeshore Flood Warning',
  RiverFloodWarning = 'River Flood Warning',
  StormSurgeWarning = 'Storm Surge Warning',
  TropicalStormWarning = 'Tropical Storm Warning',
  TsunamiWarning = 'Tsunami Warning',
  TyphoonWarning = 'Typhoon Warning',
}

export enum FloodWatchEvent {
  ArealFloodWatch = 'Areal Flood Watch',
  CoastalFloodWatch = 'Coastal Flood Watch',
  FlashFloodWatch = 'Flash Flood Watch',
  FloodWatch = 'Flood Watch',
  HurricaneWatch = 'Hurricane Watch',
  LakeshoreFloodWatch = 'Lakeshore Flood Watch',
  TropicalStormWatch = 'Tropical Storm Watch',
  TsunamiAdvisory = 'Tsunami Advisory',
  TsunamiWatch = 'Tsunami Watch',
  TyphoonWatch = 'Typhoon Watch',
  StormSurgeWatch = 'Storm Surge Watch',
}

export type FloodAlertType = FloodWarningEvent | FloodWatchEvent;
export type NWSAlertType = FireWeatherEvent | FloodAlertType;

export type NWSWarningAlertProperties = {
  date_issued_in_source: string;
  rank: number;
  subtype: 'watch' | 'warning';
  type: 'nws_fire' | 'nws_flood' | 'wea';
  highlight_on_map: boolean;
};
